import { useNewCode } from '@calendly/feature-check-react'
import { useMemo } from 'react'

const PAYPAL_PPCP_FEATURE_CODE = 'monetization_paypal_ppcp_feature'

/** Treatment arm for the PayPal PPCP experiment (not `control`). */
const PAYPAL_PPCP_FEATURE_VARIATION = 'variant'

const isPaypalPpcpFeatureVariation = (flag) => (
  flag?.variationKey === PAYPAL_PPCP_FEATURE_VARIATION
)

export const useIsPaypalPpcpFeatureVariation = () => {
  const flag = useNewCode(PAYPAL_PPCP_FEATURE_CODE, false)

  return useMemo(
    () => isPaypalPpcpFeatureVariation(flag),
    [flag],
  )
}
